import Image from '@jetshop/ui/Image';
import theme from '@jetshop/ui/utils/theme';
import React from 'react';
import { Query } from 'react-apollo';

import CategoryLink from '@jetshop/ui/CategoryLink';
import styled from 'react-emotion';
import SubCategories from './SubCategories.gql';

import Spinner from '../ui/Spinner';

const CatList = styled('div')`
  display: flex;
  flex-wrap: wrap;
  margin: 15px 0 30px 0;
  &.no-space {
    margin-top: 0;
  }
  ${theme('below.md')} {
    margin: 20px 0;
  }
`;

const SubCat = styled(CategoryLink)`
  display: flex;
  align-items: center;
  align-self: stretch;
  flex-wrap: wrap;
  justify-content: center;
  flex-grow: 1;
  position: relative;
  background: none;
  width: 25%;
  max-width: 25%;
  padding: 15px 10px;

  text-decoration: none;
  text-align: center;
  color: #000;
  font-size: 16px;
  &:nth-child(4n) {
    border-right: 0;
  }

  ${theme('below.md')} {
    width: 50%;
    max-width: 50%;

    &:nth-child(2n) {
      border-right: 0;
    }
  }
  span {
    position: relative;
    color: #000;
    max-width: 90%;
    text-align: center;
    text-transform: uppercase;
  }
  &.no-image {
    border: 1px solid #fff;
    span {
      padding: 10px;
      display: block;
      width: 100%;
      text-transform: uppercase;
    }
  }
`;
const StyledImage = styled(Image)`
  background-size: contain;
  margin-bottom: 10px;
`;

const Header = styled('header')`
  display: block;
  flex: none;
  text-align: center;
  width: 100%;
  h2 {
    text-transform: uppercase;
    font-size: 2.5rem;
    margin-bottom: 5px;
  }
  h3 {
    text-transform: uppercase;
    font-size: 1rem;
  }
`;

export default function CategoryList({ root, space, parent, grandParent }) {
  return (
    <div>
      <Header>
        <h3>Välj underkategori</h3>
      </Header>
      {root && (
        <Query
          query={SubCategories}
          variables={{
            root: grandParent ? grandParent : parent ? parent : root,
          }}
        >
          {({ loading, error, data }) => {
            if (loading) return <Spinner />;
            if (error) return `Error!: ${error}`;
            return (
              <CatList className={space}>
                {data.categories
                  .filter((cat) => {
                    return cat.id !== root && cat.parentId === root;
                  })
                  .map((cat) => {
                    return (
                      <React.Fragment key={cat.id}>
                        <SubCat
                          className={cat.images.length ? '' : 'no-image'}
                          category={cat}
                          key={cat.id}
                        >
                          {cat.images.length > 0 && (
                            <StyledImage
                              aspect="220:120"
                              sizes={[220]}
                              src={cat?.images ?? []}
                              alt={cat.name}
                              quality={80}
                            />
                          )}
                          <span>{cat.name}</span>
                        </SubCat>
                      </React.Fragment>
                    );
                  })}
              </CatList>
            );
          }}
        </Query>
      )}
    </div>
  );
}
